import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { useState, useEffect } from "react";
import { Banner, BlueCard } from "../../images";
import {
  NYC,
  Challange,
  Impact,
  Matters,
  OurApproch,
  Image1,
  Image2,
  Image3,
} from "../../images/CaseStudies";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import CaseStudy from "../parser";

const CLIENTS_BASE_URL = "http://localhost:5000";

const cards = [
  {
    category: "Government",
    title: "DOE NYC CyberSecurity",
    desc: "Strengthened IT security for over 1M students and staff with a two-year modernization program Wholesale Grocery Forecasting → Retail",
    image: Image1,
  },
  {
    category: "Retail",
    title: "Wholesale Grocery Forecasting",
    desc: "Reduced spoilage and improved inventory turnover with AI-powered demand forecasting.",
    image: Image2,
  },
  {
    category: "Financial Services",
    title: "Insurance Claims Automation",
    desc: "Automated 85% of claims processing, cutting SLA breaches and boosting customer satisfaction.",
    image: Image3,
  },
];

function CaseStudyDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [caseStudyData, setCaseStudyData] = useState(null);

  useEffect(() => {
    if (!state || !state.data) {
      navigate("/case-studies");
    }
    // console.log("state data", state.data.content);
    setCaseStudyData(state.data);
  }, []);

  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <div>
      <div className="relative min-h-[500px]">
        <img
          src={Banner}
          alt="About Banner"
          className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
        />

        <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
          <div className="max-w-[56rem] font-roboto space-y-3 mt-16">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
              <span className="text-[#475569]">Case Studies</span>
            </span>
            <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
              {caseStudyData ? caseStudyData.title : "Case Study Details"}
            </h1>
            {/* <p className="text-lg text-[#404040]">
              Industry Focus | Type of Solution
            </p> */}
            <button
              onClick={handleClick}
              type="submit"
              className="bg-activeColor mt-12 text-white text-lg md:text-xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
            >
              Contact Us
              <i className="fa fa-arrow-right text-xs mt-1"></i>
            </button>
          </div>

          <div className="max-w-xl flex justify-end mt-16">
            <img
              src={`${caseStudyData?.bannerImage}`}
              alt="Image"
              className="obkect-contain"
            />
          </div>
        </div>
      </div>

      <section className="bg-white py-16 px-3 font-roboto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
        <CaseStudy html={caseStudyData ? caseStudyData.content : ""} />
      </section>

      <section className="bg-white py-14 px-3 font-roboto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
        <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center">
          <h2 className="text-4xl md:text-7xl font-extrabold text-[#434253] mb-10">
            Related Case Studies
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {cards.map((card, i) => (
              <div key={i} className="flex flex-col items-start text-left">
                <img
                  src={card.image}
                  alt={card.title}
                  className="mb-5 w-full h-48 object-cover rounded-2xl"
                />
                <div className="text-[16px] font-500 text-[#0F172A] mb-1">
                  {card.category}
                </div>
                <div className="text-2xl font-bold text-[#0F172A] mb-1">
                  {card.title}
                </div>
                <div className="text-[#0F172A] font-400 text-lg mb-2">
                  {card.desc}
                </div>
              </div>
            ))}
          </div>

          <div>
            <a
              href="#"
              className="text-[#F42F39] font-500 text-xl inline-flex items-center"
            >
              Read Full Story <span className="ml-1">→</span>
            </a>
          </div>
        </div>
      </section>
      <div
        className="w-full h-[31vh] bg-cover bg-center bg-no-repeat md:p-0 p-5"
        style={{ backgroundImage: `url(${BlueCard})` }}
      >
        <div className="grid items-center justify-center h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-4 md:px-6">
          <div className="font-roboto text-4xl md:text-6xl text-center text-white font-medium max-w-4xl">
            <span>Ready to Create Impact in Your Business?</span>
          </div>

          <div className="w-full md:max-w-2xl gap-6 flex md:justify-end justify-center">
            <button
              type="submit"
              className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
            >
              Start Your Project
            </button>
            <button
              onClick={handleClick}
              type="submit"
              className=" text-white border-white border text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium transition-all flex items-center gap-4"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
      <ScrollToTopButton />
    </div>
  );
}
export default CaseStudyDetails;
